<template>
  <div>
    <a v-if="token != ''"
      :href="'https://' + current_host + '/inscription/' + mainStore.module.base + '/?admin_ins=' + token"
      target="_blank"><v-btn color="primary-dark" variant="outlined" density="compact">Inscrire</v-btn></a>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
import AdminService from "@/services/admin.service";
export default {
  data() {
    return {
      token: "",
      current_host: window.location.host,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },

  async mounted() {
    let res = await AdminService.getTokenViewAsAdmin(this.mainStore.module.base);
    this.token = res ? res : "";
  },
};
</script>

<style lang="scss" scoped></style>